<template>
  <div class="savethedate">
    <img :src="$root.urlsite+'documenti/savethedate.png'" />
  </div>
</template>

<script>
export default {
  name: 'savethedate'
}
</script>


<style scoped>
.savethedate{
  background: #ffffff;
  padding:0 0 0 0;
  text-align:center;
}.savethedate img{
  max-width: 1220px;
  width: 960px;
}
</style>



// WEBPACK FOOTER //
// Savethedate.vue?23424b4c